import { getSession } from 'services/apis/session';
import { VALIDATE_SESSION } from 'constants/header';

export const getSessionAction = () => ({
  type: VALIDATE_SESSION,
  payload: getSession(),
});
